<ion-item
  lines="none"
  mode="md"
  color="white"
  class="no-padding-item animated fadeIn fast"
  [ngClass]="clase"
>
  <ion-grid fixed>
    <ion-row>
      <!-- Imagen del producto -->
      <ion-col size="3" class="ion-align-self-center">
        <ion-img [src]="product.imagen" class="img-src"></ion-img>
      </ion-col>

      <!-- Descripcion del producto -->
      <ion-col [size]="colDescrip" class="ion-align-self-center ion-text-start">
        <ion-label color="status-icon-enable">
          <p class="title">
            {{ product.title }}
          </p>
          <p class="subtitle">
            {{ product.subtitle }}
          </p>

          <p class="taste">
            {{ "Labels.taste" | translate }}:&nbsp;{{ product.sku }}
          </p>

          <p class="starting-price">
            {{ product.precio | currency }} &nbsp;&nbsp;&nbsp;
            <del
              class="reduction"
              *ngIf="product.precio_original !== product.precio"
              >{{ product.precio_original | currency }}</del
            >
          </p>
        </ion-label>
      </ion-col>

      <!-- Cajas seleccionables del producto -->
      <ion-col
        [size]="colButtoms"
        style="padding-right: 0;padding-left: 0;"
        class="ion-align-self-center ion-text-center"
      >
        <!-- Producto de estatica -->
        <ng-container *ngIf="!rangeSelector">
          <ion-label color="status-icon-enable">
            {{ product.productos }}
          </ion-label>
        </ng-container>

        <!-- rango selector de dinamica -->
        <ng-container *ngIf="rangeSelector">
          <range-input
            [initial]="productsUsesReference"
            [configurations]="rangeInput"
            (comeBack)="comeBack($event, product)"
          ></range-input>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-item>
